import api from '../config/api';

export const courseService = {
    /**
     * Get all courses (for employees)
     * @returns {Promise}
     */
    getAll: async () => {
        const response = await api.get('/employee/courses');
        return response.data;
    },

    /**
     * Get course by ID (for employees)
     * @param {number} id
     * @returns {Promise}
     */
    getById: async (id) => {
        const response = await api.get(`/employee/courses/${id}`);
        return response.data;
    },

    /**
     * Get user's courses with progress
     * @returns {Promise}
     */
    getMyCourses: async () => {
        const response = await api.get('/employee/courses/my-courses');
        return response.data;
    },

    /**
     * Get course progress
     * @param {number} courseId
     * @returns {Promise}
     */
    getCourseProgress: async (courseId) => {
        const response = await api.get(`/employee/courses/${courseId}/progress`);
        return response.data;
    },

    /**
     * Start a course
     * @param {number} courseId
     * @returns {Promise}
     */
    startCourse: async (courseId) => {
        const response = await api.post(`/employee/courses/${courseId}/start`);
        return response.data;
    },

    /**
     * Start watching a video
     * @param {number} videoId
     * @returns {Promise}
     */
    startVideo: async (videoId) => {
        const response = await api.post(`/employee/courses/videos/${videoId}/start`);
        return response.data;
    },

    /**
     * Mark video as completed
     * @param {number} videoId
     * @returns {Promise}
     */
    endVideo: async (videoId) => {
        const response = await api.post(`/employee/courses/videos/${videoId}/end`);
        return response.data;
    },
};

